const PORTAL_LOGIN_PATH = '/portal-login';
const LIVE_APP_ORIGIN = 'https://mentor.mentology.com.au';

function normalizeOrigin(origin: string): string {
  return origin.trim().replace(/\/+$/, '');
}

function isLocalHost(hostname: string): boolean {
  return !hostname || hostname === 'localhost' || hostname === '127.0.0.1';
}

/** Live deploy origin override (VentraIP / production). Falls back to current browser origin. */
export function resolveAppOrigin(): string {
  const configured = import.meta.env.VITE_PUBLIC_APP_ORIGIN?.trim();
  if (configured) {
    return normalizeOrigin(configured);
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return LIVE_APP_ORIGIN;
}

/** QR codes and mobile access links always target the live portal login route. */
export function resolvePortalAccessUrl(): string {
  const configured = import.meta.env.VITE_PUBLIC_APP_ORIGIN?.trim();
  if (configured) {
    return `${normalizeOrigin(configured)}${PORTAL_LOGIN_PATH}`;
  }

  const origin = resolveAppOrigin();
  try {
    const hostname = new URL(origin).hostname;
    if (!isLocalHost(hostname)) {
      return `${origin}${PORTAL_LOGIN_PATH}`;
    }
  } catch {
    // Fall through to live origin.
  }

  return `${LIVE_APP_ORIGIN}${PORTAL_LOGIN_PATH}`;
}
